module.exports = __webpack_public_path__ + "img/4_12.559551c4.png";